import fetch from './fetch';
import env from './env';

const commFetch = params => {
  const { app } = window.$store.state;
  const config = {};
  if (app) {
    config.baseURL = env[`${app.curSysKey}Url`];
  }
  if (params.config) return fetch({ ...params, config: { ...params.config, ...config } });
  return fetch({ ...params, config });
};

export default commFetch;
